import { render, staticRenderFns } from "./questionInBank.vue?vue&type=template&id=1d577394&"
import script from "./questionInBank.vue?vue&type=script&lang=js&"
export * from "./questionInBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports